"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassOptionsOverlayContentModule = /** @class */ (function () {
    function ClassOptionsOverlayContentModule() {
    }
    return ClassOptionsOverlayContentModule;
}());
exports.ClassOptionsOverlayContentModule = ClassOptionsOverlayContentModule;
